import appConstants from "../appConstants";
import * as types from '../API/ActionTypes';
import InitialState from './initialState';

var assetFeedsLabel = "assetFeeds";
var ticketFeedsLabel = "ticketFeeds";
var userFeedsLabel = "userFeeds";

var newAssetFeedsLabel = "newAssetFeeds";
var newTicketFeedsLabel = "newTicketFeeds";
var newUserFeedsLabel = "newUserFeeds";

export function addFeedCommentErrorReducer(state = InitialState.addFeedCommentErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.ADD_FEED_COMMENT_ERROR:
			return action.addFeedCommentErrorFlag;
		default:
			return state;
	}
}

export function addFeedCommentLoadingReducer(state = InitialState.addFeedCommentLoading, action) 
{
	switch (action.type) 
	{
		case types.ADD_FEED_COMMENT_LOADING:
			return action.addFeedCommentLoading;
		default:
			return state;
	}
}

export function addUserFeedReducer(state = InitialState.addedUserFeedStatus, action) 
{
	switch (action.type) 
	{
		case types.ADD_USER_FEED:
			return action.addedUserFeedStatus;
		default:
			return state;
	}
}

export function addUserFeedErrorReducer(state = InitialState.addUserFeedErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.ADD_USER_FEED_ERROR:
			return action.addUserFeedErrorFlag;
		default:
			return state;
	}
}

export function addUserFeedLoadingReducer(state = InitialState.addUserFeedLoading, action) 
{
	switch (action.type) 
	{
		case types.ADD_USER_FEED_LOADING:
			return action.addUserFeedLoading;
		default:
			return state;
	}
}

export function feedCommentErrorReducer(state = InitialState.feedCommentErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.FEED_COMMENT_ERROR:
			return action.feedCommentErrorFlag;
		default:
			return state;
	}
}

export function feedCommentLoadingReducer(state = InitialState.feedCommentLoading, action) 
{
	switch (action.type) 
	{
		case types.FEED_COMMENT_LOADING:
			return action.feedCommentLoading;
		default:
			return state;
	}
}

export function feedCommentReducer(state = InitialState.feedComments, action) 
{
	switch (action.type) 
	{
		case types.FEED_COMMENT:
			try
			{
				return {
					feedComments: action.feedComments
				}
			} catch(error)
			{
				console.log("Load feed comments", error);
			}
			break;
		case types.ADD_FEED_COMMENT:
			try
			{
				return {
					...state,
					feedComments:
					[
						action.feedComment,
						...state.feedComments
					]
				}
			} catch(error)
			{
				console.log("Add feed comment", error);
			}
			break;
		default:
			return state;
	}
}

export function feedListErrorReducer(state = InitialState.feedOutputErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.FEED_LIST_ERROR:
			return action.feedOutputErrorFlag;
		default:
				return state;
	}
}

export function feedListLoadingReducer(state = InitialState.feedOutputDataLoading, action) 
{
	switch (action.type) 
	{
		case types.FEED_LIST_LOADING:
			return action.feedOutputDataLoading;
		default:
			return state;
	}
}

export function feedFollowOrUnfollowErrorReducer(state = InitialState.feedFollowOrUnfollowErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.FEED_FOLLOW_OR_UNFOLLOW_ERROR:
			return action.feedFollowOrUnfollowErrorFlag;
		default:
			return state;
	}
}

export function feedFollowOrUnfollowLoadingReducer(state = InitialState.feedFollowUnFollowLoading, action) 
{
	switch (action.type) 
	{
		case types.FEED_FOLLOW_OR_UNFOLLOW_LOADING:
			return action.feedFollowUnFollowLoading;
		default:
			return state;
	}
}

export function feedListReducer(state = InitialState.feedOutputData, action) 
{
	switch (action.type) 
	{
		case types.FEED_LIST:
			try 
			{
				var updatedUserFeeds = action.feedOutputData.userFeeds;
				var updatedAssetFeeds = action.feedOutputData.assetFeeds;
				var updatedTicketFeeds = action.feedOutputData.ticketFeeds;
				if (state.feedOutputData != undefined && state.feedOutputData.userFeeds != undefined && state.feedOutputData.userFeeds.length > 0) 
				{
						updatedUserFeeds = [...action.feedOutputData.userFeeds, ...state.feedOutputData.userFeeds].reduce((mergedUserFeeds, currentUserFeed) => 
						{
							var existingUserFeedIdx = mergedUserFeeds.findIndex(userFeed => userFeed.eventId === currentUserFeed.eventId);
							if (existingUserFeedIdx < 0) 
							{
									mergedUserFeeds.push(currentUserFeed);
							} else 
							{
									if (mergedUserFeeds[existingUserFeedIdx].lastUpdated < currentUserFeed.lastUpdated) 
									{
										mergedUserFeeds[existingUserFeedIdx] = currentUserFeed;
									}
							}
							return mergedUserFeeds;
						}, []);
				}

				if (state.feedOutputData != undefined && state.feedOutputData.assetFeeds != undefined && state.feedOutputData.assetFeeds.length > 0) 
				{
						updatedAssetFeeds = [...action.feedOutputData.assetFeeds, ...state.feedOutputData.assetFeeds].reduce((mergedAssetFeeds, currentAssetFeed) => 
						{
							var existingAssetFeedIdx = mergedAssetFeeds.findIndex(assetFeed => assetFeed.eventId === currentAssetFeed.eventId);
							if (existingAssetFeedIdx < 0) 
							{
									mergedAssetFeeds.push(currentAssetFeed);
							} else 
							{
									if (mergedAssetFeeds[existingAssetFeedIdx].lastUpdated < currentAssetFeed.lastUpdated) 
									{
										mergedAssetFeeds[existingAssetFeedIdx] = currentAssetFeed;
									}
							}
							return mergedAssetFeeds;
						}, []);
				}

				if (state.feedOutputData != undefined && state.feedOutputData.ticketFeeds != undefined && state.feedOutputData.ticketFeeds.length > 0) 
				{
						updatedTicketFeeds = [...action.feedOutputData.ticketFeeds, ...state.feedOutputData.ticketFeeds].reduce((mergedTicketFeeds, currentTicketFeed) => 
						{
							var existingTicketFeedIdx = mergedTicketFeeds.findIndex(ticketFeed => ticketFeed.eventId === currentTicketFeed.eventId);
							if (existingTicketFeedIdx < 0) 
							{
									mergedTicketFeeds.push(currentTicketFeed);
							} else 
							{
									if (mergedTicketFeeds[existingTicketFeedIdx].lastUpdated < currentTicketFeed.lastUpdated) 
									{
										mergedTicketFeeds[existingTicketFeedIdx] = currentTicketFeed;
									}
							}
							return mergedTicketFeeds;
						}, []);
				}

				return {
						...state,
						feedOutputData: 
						{
							...state.feedOutputData,
							userFeeds: updatedUserFeeds,
							assetFeeds: updatedAssetFeeds,
							ticketFeeds: updatedTicketFeeds
						}
				}
			} catch (error) 
			{
				return {
					...state,
					feedOutputData: 
					{
						...state.feedOutputData
					}
				}
			}
		case types.FEED_FOLLOW_OR_UNFOLLOW:
			try
			{
				var feedsLabel = (action.feed && action.feed.feedType == appConstants.FEED_TYPE_USER ? 
						userFeedsLabel : action.feed.feedType == appConstants.FEED_TYPE_ASSET ? assetFeedsLabel : 
						(action.feed.feedType == appConstants.FEED_TYPE_ASSET_TICKET || action.feed.feedType == appConstants.FEED_TYPE_USER_TICKET ? ticketFeedsLabel : ""));
				if(state.feedOutputData != undefined && state.feedOutputData[feedsLabel] != undefined && state.feedOutputData[feedsLabel].length > 0)
				{
					return {
						...state,
						feedOutputData:
						{
							...state.feedOutputData,
							[feedsLabel] : state.feedOutputData != undefined && state.feedOutputData[feedsLabel] != undefined && state.feedOutputData[feedsLabel].length > 0
							?
								[...state.feedOutputData[feedsLabel]].map(feed => (
									feed.eventId === action.feed.eventId
									?
										{
											...feed,
											follow: (action.feed.follow == 0 ? 1 : 0)
										}
									:
										{
											...feed
										}
								))
							:
								[]
						}
					}
				} else
				{
					return {
						...state,
						feedOutputData:
						{
							...state.feedOutputData
						}
					}
				}
			} catch(error)
			{
				return {
					...state,
					feedOutputData:
					{
						...state.feedOutputData
					}
				}
			}
		case types.UPDATE_NEW_FEEDS_INTO_OLD_FEEDS:
			try
			{
				var feedsLabel = (action.feedType == appConstants.FEED_TYPE_USER ? userFeedsLabel : 
					action.feedType == appConstants.FEED_TYPE_ASSET ? assetFeedsLabel : 
					action.feedType == appConstants.FEED_TYPE_ASSET_TICKET || action.feedType == appConstants.FEED_TYPE_USER_TICKET ?
					ticketFeedsLabel: "");

				if(action.newFeeds[feedsLabel] == undefined)
				{
					action.newFeeds[feedsLabel] = [];
					action.newFeeds[feedsLabel].push(action.newFeeds);
				}

				if(state.feedOutputData != undefined && state.feedOutputData[feedsLabel] != undefined && state.feedOutputData[feedsLabel].length > 0 && action.newFeeds[feedsLabel])
				{
					var updatedFeedOutputData = [...action.newFeeds[feedsLabel], ...state.feedOutputData[feedsLabel]].reduce((mergedFeeds, currentFeed) =>
					{
						var existingFeedIdx = mergedFeeds.findIndex(feed => feed.eventId === currentFeed.eventId);
						if (existingFeedIdx < 0)
						{
							mergedFeeds.push(currentFeed);
						} else
						{
							if(mergedFeeds[existingFeedIdx].lastUpdated < currentFeed.lastUpdated)
							{
								mergedFeeds[existingFeedIdx] = currentFeed;
							}
						}
						return mergedFeeds;
					}, []);

					return {
						...state,
						feedOutputData:
						{
							...state.feedOutputData,
							[feedsLabel]: (updatedFeedOutputData.length > 0 ? updatedFeedOutputData : [...state.feedOutputData[feedsLabel]])
						}
					}
				} else
				{
					return {
						...state,
						feedOutputData:
						{
							...state.feedOutputData
						}
					}
				}
			} catch(error)
			{
				return {
					...state,
					feedOutputData:
					{
						...state.feedOutputData
					}
				}
			}
		case types.REMOVE_FEED_BY_EVENT_ID:
			try
			{
				var feedsLabel = (action.feedType == appConstants.FEED_TYPE_USER ? 
					userFeedsLabel : action.feedType == appConstants.FEED_TYPE_ASSET ? assetFeedsLabel : 
					(action.feedType == appConstants.FEED_TYPE_ASSET_TICKET || action.feedType == appConstants.FEED_TYPE_USER_TICKET ? ticketFeedsLabel : ""));
				if(state.feedOutputData != undefined && state.feedOutputData[feedsLabel] != undefined && state.feedOutputData[feedsLabel].length > 0)
				{
					return {
						...state,
						feedOutputData:
						{
							...state.feedOutputData,
							[feedsLabel]: [...state.feedOutputData[feedsLabel]].filter(feed => feed.eventId !== action.feed.eventId)
						}
					}
				} else
				{
					return {
						...state,
						feedOutputData:
						{
							...state.feedOutputData
						}
					}
				}
			} catch(error)
			{
				return {
					...state,
					feedOutputData:
					{
						...state.feedOutputData
					}
				}
			}
		case types.REMOVE_FEED_LIST:
			return {
				...state,
				feedOutputData: action.feedOutputData
			}
		default:
			return state;
	}
}

export function assetFeedListReducer(state = InitialState.assetFeedOutputData, action) 
{
	switch (action.type) 
	{
		case types.ASSET_FEED_LIST:
			try 
			{
				var updatedAssetFeeds = action.assetFeedOutputData ? action.assetFeedOutputData.assetFeeds : {};
				var updatedTicketFeeds = action.assetFeedOutputData ? action.assetFeedOutputData.ticketFeeds : {};

				if (state.assetFeedOutputData != undefined && state.assetFeedOutputData.assetFeeds != undefined && state.assetFeedOutputData.assetFeeds.length > 0 
						&& action.assetFeedOutputData &&  action.assetFeedOutputData.assetFeeds) 
				{
						updatedAssetFeeds = [...action.assetFeedOutputData.assetFeeds, ...state.assetFeedOutputData.assetFeeds].reduce((mergedAssetFeeds, currentAssetFeed) => 
						{
							var existingAssetFeedIdx = mergedAssetFeeds.findIndex(assetFeed => assetFeed.eventId === currentAssetFeed.eventId);
							if (existingAssetFeedIdx < 0) 
							{
									mergedAssetFeeds.push(currentAssetFeed);
							} else 
							{
									if (mergedAssetFeeds[existingAssetFeedIdx].lastUpdated < currentAssetFeed.lastUpdated) 
									{
										mergedAssetFeeds[existingAssetFeedIdx] = currentAssetFeed;
									}
							}
							return mergedAssetFeeds;
						}, []);
				}

				if (state.assetFeedOutputData != undefined && state.assetFeedOutputData.ticketFeeds != undefined && state.assetFeedOutputData.ticketFeeds.length > 0 
						&& action.assetFeedOutputData && action.assetFeedOutputData.ticketFeeds) 
				{
						updatedTicketFeeds = [...action.assetFeedOutputData.ticketFeeds, ...state.assetFeedOutputData.ticketFeeds].reduce((mergedTicketFeeds, currentTicketFeed) => 
						{
							var existingTicketFeedIdx = mergedTicketFeeds.findIndex(ticketFeed => ticketFeed.eventId === currentTicketFeed.eventId);
							if (existingTicketFeedIdx < 0) 
							{
									mergedTicketFeeds.push(currentTicketFeed);
							} else 
							{
									if (mergedTicketFeeds[existingTicketFeedIdx].lastUpdated < currentTicketFeed.lastUpdated) 
									{
										mergedTicketFeeds[existingTicketFeedIdx] = currentTicketFeed;
									}
							}
							return mergedTicketFeeds;
						}, []);
				}

				return {
						...state,
						assetFeedOutputData: 
						{
							...state.assetFeedOutputData,
							assetFeeds: updatedAssetFeeds,
							ticketFeeds: updatedTicketFeeds
						}
				}
			} catch (error) 
			{
				return {
					...state,
					assetFeedOutputData: 
					{
						...state.assetFeedOutputData
					}
				}
			}
		case types.ASSET_FEED_FOLLOW_OR_UNFOLLOW:
			try
			{
				var feedsLabel = (action.feed.feedType == appConstants.FEED_TYPE_ASSET ? assetFeedsLabel : 
					(action.feed.feedType == appConstants.FEED_TYPE_ASSET_TICKET || action.feed.feedType == appConstants.FEED_TYPE_USER_TICKET ? ticketFeedsLabel : ""));
				if(state.assetFeedOutputData != undefined && state.assetFeedOutputData[feedsLabel] != undefined && state.assetFeedOutputData[feedsLabel].length > 0)
				{
					return {
						...state,
						assetFeedOutputData:
						{
							...state.assetFeedOutputData,
							[feedsLabel] : state.assetFeedOutputData != undefined && state.assetFeedOutputData[feedsLabel] != undefined && state.assetFeedOutputData[feedsLabel].length > 0
							?
								[...state.assetFeedOutputData[feedsLabel]].map(feed => (
									feed.eventId === action.feed.eventId
									?
										{
											...feed,
											follow: (action.feed.follow == 0 ? 1 : 0)
										}
									:
										{
											...feed
										}
								))
							:
								[]
						}
					}
				} else
				{
					return {
						...state,
						assetFeedOutputData:
						{
							...state.assetFeedOutputData
						}
					}
				}
			} catch(error)
			{
				return {
					...state,
					assetFeedOutputData:
					{
						...state.assetFeedOutputData
					}
				}
			}		
		case types.UPDATE_NEW_ASSET_HISTORY_FEEDS_INTO_OLD_ASSET_HISTORY_FEEDS:
			try
			{
				var feedsLabel = (action.feedType == appConstants.FEED_TYPE_USER ? userFeedsLabel : 
					action.feedType == appConstants.FEED_TYPE_ASSET ? assetFeedsLabel : 
					action.feedType == appConstants.FEED_TYPE_ASSET_TICKET || action.feedType == appConstants.FEED_TYPE_USER_TICKET ?
					ticketFeedsLabel: "");

				if(action.newFeeds[feedsLabel] == undefined)
				{
					action.newFeeds[feedsLabel] = [];
					action.newFeeds[feedsLabel].push(action.newFeeds);
				}

				if(state.assetFeedOutputData != undefined && state.assetFeedOutputData[feedsLabel] != undefined && state.assetFeedOutputData[feedsLabel].length > 0 && action.newFeeds[feedsLabel])
				{
					var updatedFeedOutputData = [...action.newFeeds[feedsLabel], ...state.assetFeedOutputData[feedsLabel]].reduce((mergedFeeds, currentFeed) =>
					{
						var existingFeedIdx = mergedFeeds.findIndex(feed => feed.eventId === currentFeed.eventId);
						if (existingFeedIdx < 0)
						{
							mergedFeeds.push(currentFeed);
						} else
						{
							if(mergedFeeds[existingFeedIdx].lastUpdated < currentFeed.lastUpdated)
							{
								mergedFeeds[existingFeedIdx] = currentFeed;
							}
						}
						return mergedFeeds;
					}, []);

					return {
						...state,
						assetFeedOutputData:
						{
							...state.assetFeedOutputData,
							[feedsLabel]: (updatedFeedOutputData.length > 0 ? updatedFeedOutputData : [...state.assetFeedOutputData[feedsLabel]])
						}
					}
				} else
				{
					return {
						...state,
						assetFeedOutputData:
						{
							...state.assetFeedOutputData
						}
					}
				}
			} catch(error)
			{
				return {
					...state,
					assetFeedOutputData:
					{
						...state.assetFeedOutputData
					}
				}
			}		
		case types.REMOVE_ASSET_HISTORY_FEED_BY_EVENT_ID:
			try
			{
				var feedsLabel = (action.feedType == appConstants.FEED_TYPE_USER ? 
					userFeedsLabel : action.feedType == appConstants.FEED_TYPE_ASSET ? assetFeedsLabel : 
					(action.feedType == appConstants.FEED_TYPE_ASSET_TICKET || action.feedType == appConstants.FEED_TYPE_USER_TICKET ? ticketFeedsLabel : ""));
				if(state.assetFeedOutputData != undefined && state.assetFeedOutputData[feedsLabel] != undefined && state.assetFeedOutputData[feedsLabel].length > 0)
				{
					return {
						...state,
						assetFeedOutputData:
						{
							...state.assetFeedOutputData,
							[feedsLabel]: [...state.assetFeedOutputData[feedsLabel]].filter(feed => feed.eventId !== action.feed.eventId)
						}
					}
				} else
				{
					return {
						...state,
						assetFeedOutputData:
						{
							...state.assetFeedOutputData
						}
					}
				}
			} catch(error)
			{
				return {
					...state,
					assetFeedOutputData:
					{
						...state.assetFeedOutputData
					}
				}
			}
		default:
			return state;
	}
}

export function refreshFeedListErrorReducer(state = InitialState.refreshFeedOutputErrorFlag, action) 
{
	switch (action.type)
	{
		case types.REFRESH_FEED_LIST_ERROR:
			return action.refreshFeedOutputErrorFlag;
		default:
				return state;
	}
}

export function refreshFeedListLoadingReducer(state = InitialState.refreshFeedOutputDataLoading, action) 
{
	switch (action.type) 
	{
		case types.REFRESH_FEED_LIST_LOADING:
			return action.refreshFeedOutputDataLoading;
		default:
			return state;
	}
}

export function newFeedListReducer(state = InitialState.newFeedOutputData, action)
{
	switch (action.type)
	{
		case types.NEW_FEED_LIST:
			try
			{
				var updatedNewUserFeeds = action.newFeedOutputData != undefined ? action.newFeedOutputData.newUserFeeds : [];
				var updatedNewAssetFeeds = action.newFeedOutputData != undefined ? action.newFeedOutputData.newAssetFeeds : [];
				var updatedNewTicketFeeds = action.newFeedOutputData != undefined ? action.newFeedOutputData.newTicketFeeds : [];

				if(state.newFeedOutputData != undefined && state.newFeedOutputData.newUserFeeds != undefined && state.newFeedOutputData.newUserFeeds.length > 0)
				{
					updatedNewUserFeeds = [...action.newFeedOutputData.newUserFeeds, ...state.newFeedOutputData.newUserFeeds].reduce((mergedNewUserFeeds, currentNewUserFeed) =>
					{
						var existingNewUserFeedIdx = mergedNewUserFeeds.findIndex(newUserFeed => newUserFeed.eventId === currentNewUserFeed.eventId);
						if (existingNewUserFeedIdx < 0)
						{
							mergedNewUserFeeds.push(currentNewUserFeed);
						} else
						{
							mergedNewUserFeeds[existingNewUserFeedIdx] = currentNewUserFeed;
						}
						return mergedNewUserFeeds;
					}, []);
				}

				if(state.newFeedOutputData != undefined && state.newFeedOutputData.newAssetFeeds != undefined && state.newFeedOutputData.newAssetFeeds.length > 0)
				{
					updatedNewAssetFeeds = [...action.newFeedOutputData.newAssetFeeds, ...state.newFeedOutputData.newAssetFeeds].reduce((mergedNewAssetFeeds, currentNewAssetFeed) =>
					{
						var existingNewAssetFeedIdx = mergedNewAssetFeeds.findIndex(newAssetFeed => newAssetFeed.eventId === currentNewAssetFeed.eventId);
						if (existingNewAssetFeedIdx < 0)
						{
							mergedNewAssetFeeds.push(currentNewAssetFeed);
						} else
						{
							mergedNewAssetFeeds[existingNewAssetFeedIdx] = currentNewAssetFeed;
						}
						return mergedNewAssetFeeds;
					}, []);
				}

				if(state.newFeedOutputData != undefined && state.newFeedOutputData.newTicketFeeds != undefined && state.newFeedOutputData.newTicketFeeds.length > 0)
				{
					updatedNewTicketFeeds = [...action.newFeedOutputData.newTicketFeeds, ...state.newFeedOutputData.newTicketFeeds].reduce((mergedNewTicketFeeds, currentNewTicketFeed) =>
					{
						var existingNewTicketFeedIdx = mergedNewTicketFeeds.findIndex(newTicketFeed => newTicketFeed.eventId === currentNewTicketFeed.eventId);
						if (existingNewTicketFeedIdx < 0)
						{
							mergedNewTicketFeeds.push(currentNewTicketFeed);
						} else
						{
							mergedNewTicketFeeds[existingNewTicketFeedIdx] = currentNewTicketFeed;
						}
						return mergedNewTicketFeeds;
					}, []);
				}

				return {
					...state,
					newFeedOutputData:
					{
						...state.newFeedOutputData,
						newUserFeeds: updatedNewUserFeeds,
						newAssetFeeds: updatedNewAssetFeeds,
						newTicketFeeds: updatedNewTicketFeeds
					}
				}
			} catch (error)
			{
				return {
					...state,
					newFeedOutputData:
					{
						...state.newFeedOutputData
					}
				}
			};

		case types.REMOVE_NEW_FEED_BY_EVENT_ID:
			try
			{
				var newFeedsLabel = (action.feedType == appConstants.FEED_TYPE_USER ? 
					newUserFeedsLabel : action.feedType == appConstants.FEED_TYPE_ASSET ? newAssetFeedsLabel : 
					(action.feedType == appConstants.FEED_TYPE_ASSET_TICKET || action.feedType == appConstants.FEED_TYPE_USER_TICKET ? newTicketFeedsLabel : ""));
				if(state.newFeedOutputData != undefined && state.newFeedOutputData[newFeedsLabel] != undefined && state.newFeedOutputData[newFeedsLabel].length > 0)
				{
					return {
						...state,
						newFeedOutputData:
						{
							...state.newFeedOutputData,
							[newFeedsLabel]: [...state.newFeedOutputData[newFeedsLabel]].filter(newFeed => newFeed.eventId !== action.newFeed.eventId)
						}
					}
				} else
				{
					return {
						...state,
						newFeedOutputData:
						{
							...state.newFeedOutputData
						}
					}
				}
			} catch(error)
			{
				return {
					...state,
					newFeedOutputData:
					{
						...state.newFeedOutputData
					}
				}
			}
		case types.REMOVE_NEW_FEEDS_BY_FEED_TYPE:
			try
			{
				var newFeedsLabel = (action.feedType == appConstants.FEED_TYPE_USER ? 
					newUserFeedsLabel : action.feedType == appConstants.FEED_TYPE_ASSET ? newAssetFeedsLabel : 
					(action.feedType == appConstants.FEED_TYPE_ASSET_TICKET || action.feedType == appConstants.FEED_TYPE_USER_TICKET ? newTicketFeedsLabel : ""));
				if(state.newFeedOutputData != undefined && state.newFeedOutputData[newFeedsLabel] != undefined && state.newFeedOutputData[newFeedsLabel].length > 0)
				{
					return {
						...state,
						newFeedOutputData:
						{
							...state.newFeedOutputData,
							[newFeedsLabel]: []
						},
					}
				} else
				{
					return {
						...state,
						newFeedOutputData:
						{
							...state.newFeedOutputData
						}
					}
				}
			} catch(error)
			{
				return {
					...state,
					newFeedOutputData:
					{
						...state.newFeedOutputData
					}
				}
			}
		case types.REMOVE_NEW_FEEDS:
			try
			{
				return {
					newFeedOutputData:
					{
						newUserFeeds: [],
						newAssetFeeds: [],
						newTicketFeeds: []
					}
				}
			} catch(error)
			{
				return {
					newFeedOutputData:
					{
						newUserFeeds: [],
						newAssetFeeds: [],
						newTicketFeeds: []
					}
				}
			}
		default:
			return state;
	}
}

export function feedsLastUpdatedDateTimeReducer(state = InitialState.feedsLastUpdatedDateTime, action)
{
	switch (action.type)
	{
		case types.FEEDS_LAST_UPDATED_DATE_TIME:
			return action.feedsLastUpdatedDateTime;
		default:
			return state;
	}
}

export function newFeedsCountReducer(state = InitialState.newFeedsCount, action)
{
	switch (action.type)
	{
		case types.NEW_FEEDS_COUNT:
			return action.newFeedsCount;
		default:
			return state;
	}
}

export function updateNewFeedsIntoOldFeedsLoadingReducer(state = InitialState.updateNewFeedsIntoOldFeedsLoading, action) 
{
	switch (action.type) 
	{
		case types.UPDATE_NEW_FEEDS_INTO_OLD_FEEDS_LOADING:
			return action.updateNewFeedsIntoOldFeedsLoading;
		default:
			return state;
	}
}